import { clsx } from 'clsx';

import type { LineLoaderProps } from './types';

type UseLineLoaderView = (
  props: LineLoaderProps,
  classes: Record<string, string>,
) => {
  rootProps: {
    className?: string;
  };
  ribbonProps: {
    className?: string;
  };
};

export const useLineLoaderView: UseLineLoaderView = (
  { color = 'primary', position = 'static' },
  classes,
) => {
  return {
    rootProps: {
      className: clsx(classes.root, {
        [classes[`position-${position}`]]: position,
      }),
    },
    ribbonProps: {
      className: clsx(classes.ribbon, {
        [classes[`color-${color}`]]: color,
      }),
    },
  };
};
